import React from "react";
import { inject, observer } from "mobx-react";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils, LocaleUtils } from 'react-day-picker';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';



function parseDate(str, format, locale) {

    //console.log("parseDate", str, format, locale);
    const parsed = dateFnsParse(str, format, new Date(), { locale });
    if (DateUtils.isDate(parsed)) {
        //console.log("parsed:", parsed);
        return parsed;
    }
    return undefined;
}

function formatDate(date, format, locale) {
    //console.log("formatDate", date, format, locale);
    return dateFnsFormat(date, format, { locale });
}


function getFirstDayOfWeek(locale) {

    return 1; // monday;
}



@inject("store")
@observer

export default class PurchaseOrderSettingsEdit extends React.Component {

    DATE_FORMAT = 'yyyy-MM-dd';

    constructor(props) {
        super(props);

        this.changeOrderReference = this.changeOrderReference.bind(this);
        this.handleOrderTemplateChange = this.handleOrderTemplateChange.bind(this);
        this.handleOrderDateChange = this.handleOrderDateChange.bind(this);
        this.beginPurchase = this.beginPurchase.bind(this);
        this.state = {
            orderTemplates: [],
            allowDateChange: false,
            editOrder: false,
            editOrderReference: ""
        };
    }


    handleOrderTemplateChange(e, orderTemplate) {

        this.props.store.order.activeOrder.setOrderTemplate(orderTemplate.Name);
    }

    handleOrderDateChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.getInput();
        console.log(input);
        this.props.store.order.activeOrder.setDeliveryDate(input.value);
    }

    beginPurchase(e) {
        e.preventDefault();
        const navigation = this.props.store.navigation;
        console.log("beginPurchase selectedSiteUrl: ", this.state.selectedSiteUrl);
        //this.props.store.navigation.navigateToSiteUrl(null, this.state.selectedSiteUrl, name);
        navigation.closeChoose();
    }

    changeOrderReference(value) {
        this.setState({ editOrderReference: value });
    }

    componentDidMount() {
        const navigation = this.props.store.navigation;
        // console.debug("componentDidMount -> getOrderTemplates");
        // this.props.store.order.getOrderTemplates(navigation.SiteId).then(orderTemplates => {
        //     this.setState({
        //         orderTemplates: orderTemplates.filter(x => x.PurchaseOrder)
        //     });
        // });
    }


    render() {
        const orderStore = this.props.store.order;

        if (!orderStore.activeOrder) {
            return (<div>Loading settings...</div>);
        }
        return (
            <React.Fragment>
                <h4 className="card-title text-center my-5">
                    Redigera order: {orderStore.activeOrder.OrderNumber}</h4>
                {/*<div className="margin-bottom-1x">*/}
                {/*    <h6 className="text-muted text-normal text-uppercase">Order type</h6>*/}
                {/*    <hr className="mb-2" />*/}
                {/*    {!orderStore.activeOrder.OrderTemplateName || this.state.orderTemplates.find(ot => ot.Name === orderStore.activeOrder.OrderTemplateName)*/}
                {/*        ? null*/}
                {/*        : <div key={orderStore.activeOrder.OrderTemplateName}>*/}
                
                {/*            <div className="custom-control custom-radio">*/}
                {/*                <input className="custom-control-input" type="radio"*/}
                {/*                    id={"orderTemplate_" + orderStore.activeOrder.OrderTemplateName}*/}
                {/*                    name="orderTemplateName"*/}
                {/*                    value={orderStore.activeOrder.OrderTemplateName}*/}
                {/*                    checked={true}*/}
                
                {/*                    onChange={(e) => { this.handleOrderTemplateChange(e, null) }}*/}
                {/*                />*/}
                {/*                <label className="custom-control-label" htmlFor={"orderTemplate_" +*/}
                {/*                    orderStore.activeOrder.OrderTemplateName}>*/}
                {/*                    <strong>{orderStore.activeOrder.OrderTemplateName}</strong>: {*/}
                {/*                        orderStore.activeOrder.OrderType}<br /> [{orderStore.activeOrder.OrderWarehouseStart}{*/}
                {/*                        (orderStore.activeOrder.OrderWarehouseEnd !== orderStore.activeOrder.OrderWarehouseStart)*/}
                {/*                            ? (" -- " + orderStore.activeOrder.OrderWarehouseEnd)*/}
                {/*                            : ""}]</label>*/}
                
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    }*/}
                
                
                {/*    {this.state.orderTemplates.map(orderTemplate => {*/}
                {/*        return (*/}
                {/*            <div key={orderTemplate.Name}>*/}
                
                {/*                <div className="custom-control custom-radio">*/}
                {/*                    <input className="custom-control-input" type="radio"*/}
                {/*                        id={"orderTemplate_" + orderTemplate.Name}*/}
                {/*                        name="orderTemplateName"*/}
                {/*                        value={orderTemplate.Name}*/}
                {/*                        checked={orderTemplate.Name === orderStore.activeOrder.OrderTemplateName}*/}
                {/*                        onChange={(e) => { this.handleOrderTemplateChange(e, orderTemplate) }} />*/}
                {/*                    <label className="custom-control-label" htmlFor={"orderTemplate_" + orderTemplate.Name}>*/}
                {/*                        <strong>{orderTemplate.Name}</strong>: {orderTemplate.OrderType*/}
                {/*                        }<br />Available shipment dates: [{orderTemplate.StartDate}{*/}
                {/*                            (orderTemplate.EndDate !== orderTemplate.StartDate)*/}
                {/*                                ? (" -- " + orderTemplate.EndDate)*/}
                {/*                                : ""}]</label>*/}
                
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        );*/}
                {/*    })}*/}
                {/*</div>*/}
                {/*<hr className="mb-2" />*/}
                <h6 className="text-muted text-normal text-uppercase">Önskat leveransdatum</h6>

                <div className="form-group">
                    <DayPickerInput
                        className="form-control form-control-sm"
                        formatDate={formatDate}
                        format={this.DATE_FORMAT}
                        parseDate={parseDate}
                        value={orderStore.activeOrder.DeliveryDate}

                        dayPickerProps={{
                            selectedDays: parseDate(orderStore.activeOrder.DeliveryDate, this.DATE_FORMAT),
                            localeUtils: { ...LocaleUtils, getFirstDayOfWeek }
                        }}
                        onDayChange={this.handleOrderDateChange}
                    />

                </div>
                <hr className="mb-2" />
                <h6 className="text-muted text-normal text-uppercase">Din beställningsreferens</h6>

                <div className="form-group">
                    <div className="add-order-reference"
                        style={{ display: "flex", fontSize: 16 }}>



                        <input
                            className="form-control form-control-sm"
                            style={{ width: "100%" }}
                            type="text" value={orderStore.activeOrder.Reference}
                            onChange={(e) => { orderStore.activeOrder.setReference(e.target.value) }}
                            onBlur={(e) => {
                                orderStore.activeOrder.update();
                            }}

                            placeholder="Ange en egen beställningsreferens "
                        />


                    </div>
                </div>

            </React.Fragment>

        );
    }

}